import { useQuery } from "@tanstack/react-query";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { apiClient } from "../service/tekkr-service";

export function useGetInviteQuery(token: string) {
    return useQuery({
        queryKey: ["invite", token],
        queryFn: async () => {
            const response = await (await apiClient).getInvite({ params: { token } });
            return response.body as ClientInferResponseBody<typeof apiContract.getInvite, 200>;
        },
    });
}
